import styled from 'styled-components';

export const RemoveMockupModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5625rem;
`;
